
import { defineComponent, SetupContext, PropType } from "vue";
import { CommonRecipe } from "@/types/commonRecipe";
import RecipeTopListItem from "./RecipeTopListItem.vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "RecipeTopList",
  components: { RecipeTopListItem },
  props: {
    recipes: {
      type: Array as PropType<CommonRecipe[]>,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    const selectRecipe = (recipeId: number, reciepType: string) => {
      NativeClient.sendDebugLog("RecipeTopList onClick recipeId=" + recipeId + " recipeType=" + reciepType);
      context.emit('select-recipe', recipeId, reciepType);
    };
    const getRecipes = (recipes: Array<CommonRecipe>) => {
      if (recipes != null) {
        return recipes;
      } else {
        return null;
      }
    };
    return {
      getRecipes,
      selectRecipe
    };
  }
});
